import { render } from "./widget-logs.vue?vue&type=template&id=1f517866"
import script from "./widget-logs.vue?vue&type=script&lang=js"
export * from "./widget-logs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__